import { useI18n } from "@core/i18n/i18n";
import { programOperationsManager } from "@core/service-container";
// ProgramId import removed - now using string type instead
import { ToastContext } from "@ui/components/common/toast-provider";
import { ConfirmActionDialog } from "@ui/pages/program-builder/dialog/confirm-dialog";
import { DialogProps } from "primereact/dialog";
import React, { useCallback, useContext, useState } from "react";

export interface DeleteProgramDialogProps extends DialogProps {
	patient: { id: string; analyticsId: string };
	program: { id: string; name: string };
	onSuccess?: () => void;
}

export const DeleteProgramDialog = ({
	patient,
	program,
	onSuccess,
	...otherProps
}: DeleteProgramDialogProps): JSX.Element => {
	const { format } = useI18n();
	const { showToast } = useContext(ToastContext);

	const [awaitingDelete, setAwaitingDelete] = useState(false);

	const deleteProgram = useCallback(async () => {
		setAwaitingDelete(true);
		try {
			await programOperationsManager.performDeleteOperation(patient.id, program.id);
			setAwaitingDelete(false);
			onSuccess?.();
			otherProps.onHide();
			showToast(
				format("global.deleteProgramOperation.successToast.title"),
				format("global.deleteProgramOperation.successToast.message", { program: program.name }),
				"success",
			);
		} catch (error) {
			console.error("Failed to delete program", error);
			setAwaitingDelete(false);
			showToast(
				format("global.deleteProgramOperation.errorToast.title"),
				format("global.deleteProgramOperation.errorToast.message"),
			);
		}
	}, [format, onSuccess, otherProps, patient.id, program.id, program.name, showToast]);

	return (
		<ConfirmActionDialog
			{...otherProps}
			onCancel={otherProps.onHide}
			onConfirm={deleteProgram}
			confirmLoading={awaitingDelete}
			title={format("programBuilder.deleteDialog.header")}
			message={format("programBuilder.deleteDialog.message")}
		/>
	);
};
